import React from "react";

const Tech = () => (
  <section>
    <span id="tech" className="section-link" />
    <div>
      <h2>Technologies </h2>
      <h3>Recent technologies include:</h3>

      <ul className="feature-list">
        <li>Vanilla JavaScript (OOP and Functional)</li>
        <li>React</li>
        <li>Redux</li>
        <li>Node.js</li>
        <li>Gatsby</li>
        <li>GraphQL</li>
        <li>Shopify Plus</li>
        <li>CSS-in-JS</li>
      </ul>
    </div>
  </section>
);

export default Tech;
